export var INITIAL_VALUE = '';
export var COUNTRY_OPTIONS = ['US', 'GB', '...'];
export var DEFAULT_COUNTRY = 'US';